import { Component } from '@angular/core';
import {Events, IonicPage, ModalController, NavController, NavParams} from 'ionic-angular';
import {SplashScreen} from "@ionic-native/splash-screen";
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";
import {IntroWelcomePage} from "../intro-welcome/intro-welcome";
import {InitHelloPage} from "../init-hello/init-hello";
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {AppVideoDetailsPage} from "../app-video-details/app-video-details";
import {AppModuleListPage} from "../app-module-list/app-module-list";
import {AppVideoPlayerPage} from "../app-video-player/app-video-player";
import {AppChatDetailsPage} from "../app-chat-details/app-chat-details";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {AppPaymentPage} from "../app-payment/app-payment";
import {LoginPage} from "../login/login";
import {AppStatsPage} from "../app-stats/app-stats";
import {AppForumListPage} from "../app-forum-list/app-forum-list";
import {AppMyWayPage} from "../app-my-way/app-my-way";
import {AppMoodUpdatePage} from "../app-mood-update/app-mood-update";
import {AppStepUpdatePage} from "../app-step-update/app-step-update";
import {PasswordForgottenUpdatePage} from "../password-forgotten-update/password-forgotten-update";
import {AppVideoTipsPage} from "../app-video-tips/app-video-tips";
import {AppSettingsTrainingPopupPage} from "../app-settings-training-popup/app-settings-training-popup";
import {InitPrescriptionPage} from "../init-prescription/init-prescription";
import {IntroNamePage} from "../intro-name/intro-name";
import {AppStatsIntroPage} from "../app-stats-intro/app-stats-intro";
import {AppStatsFoodPage} from "../app-stats-food/app-stats-food";
import {AppChallengeIntroPage} from "../app-challenge-intro/app-challenge-intro";
import {AppChallengeUserPage} from "../app-challenge-user/app-challenge-user";
import {DebugPage} from "../debug/debug";

/**
 * Generated class for the SplashPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-splash',
  templateUrl: 'splash.html',
})
export class SplashPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public splashScreen: SplashScreen, public apiAuth: ApiAuthProvider, public contentTranslation: ContentTranslationProvider, public events: Events, public modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
    var me = this;

    this.events.subscribe('password-forgotten-request', (payload) => {
      this.navCtrl.push(PasswordForgottenUpdatePage, payload)
    });

    var loadContentTranslationPromise = this.contentTranslation.loadData();
    var refreshPromise = new Promise((resolve, reject) => {
      console.log('create refresh promise')
      this.apiAuth.tryToRefreshSession().then(resolve).catch(resolve);
    });

    Promise.all([loadContentTranslationPromise, refreshPromise]).then((values) => {
      console.log(values);
      var res = values[1] as any;
      if(!res || !res.user) {
        if(window.location.search.indexOf('page=login')> -1) {
          me.navCtrl.setRoot(LoginPage);
        } else {
          me.navCtrl.setRoot(IntroWelcomePage);
        }
      } else if(window.location.host == 'localhost:8100' && (window.localStorage as any).debugEnabled) {
        me.navCtrl.setRoot(DebugPage)
      } else if(res.user.status > 1) {
        // me.navCtrl.setRoot(AppChallengeIntroPage);
        me.navCtrl.setRoot(AppDashboardPage)
      } else if(!res.user.prescriptionCode && (!res.user.insurance || !res.user.insurance.type)) {
        me.navCtrl.setRoot(InitPrescriptionPage)
      } else if(!res.user.firstName) {
        me.navCtrl.setRoot(IntroNamePage)
      } else {
        me.navCtrl.setRoot(InitHelloPage);
      }

      me.splashScreen.hide();
      console.log('hide splash screen');
    }, (err) => {
      me.navCtrl.setRoot(IntroWelcomePage);
      me.splashScreen.hide();
      console.log('hide splash screen err', err);
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/splash/splash.ts